import { render, staticRenderFns } from "./fields.vue?vue&type=template&id=6c68dbf6&scoped=true"
import script from "./fields.vue?vue&type=script&lang=js"
export * from "./fields.vue?vue&type=script&lang=js"
import style0 from "./fields.vue?vue&type=style&index=0&id=6c68dbf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c68dbf6",
  null
  
)

export default component.exports